"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMessages = void 0;
var _react = require("react");
var _TaskManager = require("../TaskManager.provider");
const useMessages = () => {
  const {
    setShowReadOnlyMessageTiming,
    showReadOnlyMessageTiming,
    setShowReadOnlyMessageGroups,
    showReadOnlyMessageGroups
  } = (0, _react.useContext)(_TaskManager.TaskManagerContext);
  // const timerRef = useRef<ReturnType<typeof setTimeout>>();

  (0, _react.useEffect)(() => {
    let isActive = true;
    let timer = null;
    const off = () => {
      if (isActive) {
        setShowReadOnlyMessageTiming(null);
      }
      if (timer) {
        timer = null;
      }
    };
    if (showReadOnlyMessageTiming) {
      timer = window.setTimeout(off, 5 * 60000);
    }
    return () => {
      isActive = false;
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    };
  }, [setShowReadOnlyMessageTiming, showReadOnlyMessageTiming]);
  (0, _react.useEffect)(() => {
    let isActive = true;
    let timer = null;
    const off = () => {
      if (isActive) {
        setShowReadOnlyMessageGroups(null);
      }
      if (timer) {
        timer = null;
      }
    };
    if (showReadOnlyMessageGroups) {
      timer = window.setTimeout(off, 5 * 60000);
    }
    return () => {
      isActive = false;
      if (timer) {
        window.clearTimeout(timer);
        timer = null;
      }
    };
  }, [setShowReadOnlyMessageGroups, showReadOnlyMessageGroups]);
};
exports.useMessages = useMessages;